import { useMemo } from 'react';
import { Paper, Typography, LinearProgress } from '@material-ui/core';
import Chart from '@components/core/Chart';

const groupBy = function(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export default function Tasks(props) {
  const { data } = props
  if (!data) {
    return (
      <>
        <Typography variant="h6" color="text">
          每日任務完成
        </Typography>
        <Paper elevation={0}>
          <LinearProgress />
        </Paper>
      </>
    )
  }

  const groupedData = groupBy(
    data?.tasks_by_date || [],
    'date'
  )
  const sourceData = (data?.dates || []).map(date => {
    if (!groupedData[date]) {
      return { date, DONE: 0, UNDONE: 0 }
    }

    const DONE = groupedData[date].find(row => row.status === 'DONE')?.count || 0
    const UNDONE =  groupedData[date]
      .filter(row => row.status !== 'DONE')
      .reduce((pre, cur) => cur.count + pre, 0)

    return { date, DONE, UNDONE }
  })

  const OPTION = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    toolbox: {
      show: true,
      orient: 'vertical',
      left: 'right',
      top: 'center',
    },
    legend: {
      data: ['DONE', 'UNDONE']
    },
    dataset: {
      dimensions: ['date', 'DONE', 'UNDONE'],
      source: sourceData,
    },
    xAxis: { type: 'category' },
    yAxis: {},
    series: [
      {
        type: 'line',
      },
      {
        type: 'line',
      },
    ]
  }

  return (
    <>
      <Typography variant="h6" color="text">
        每日任務完成
      </Typography>
      <Paper elevation={0}>
        <Chart
          option={OPTION}
          style={{
            height: '300px',
          }}
        />
      </Paper>
    </>
  );
}
